import React, { useState } from "react";
import CkEditor from "../../CkEditor/CkEditor";

const NormalText = (props) => {
  const { title, setter, type, index, handleFocus, data, isEditable } = props;

  const [state, setState] = useState(data);

  // propagate synchronously so the parent always has the latest value before a blur-triggered save fires
  const handleChangeText = (ev, value) => {
    const newState = { ...state, text: value };
    setState(newState);
    setter(type, newState, index);
  };

  return (
    <div className="fieldContainer">
      <div className="fieldHeader">
        <div className="fieldTitle">
          <span>{title}</span>
        </div>
      </div>

      <div className="editorArea">
        {isEditable ? (
          <CkEditor
            key={`normaltext-${index}-${data.id || index}-edit`}
            onChange={handleChangeText}
            onFocus={() => handleFocus(true)}
            onBlur={() => handleFocus(false)}
            data={data}
          />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: data.text }} />
        )}
      </div>
    </div>
  );
};

export default NormalText;
